module.exports = __webpack_public_path__ + "static/media/GDocsPortalSiteTnC_EN.d5a88e45.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cust_PDF/GDocsPortalSiteTnC_EN.pdf
// module id = 284
// module chunks = 4